<template>
    <div
        class="page-container page-container--height chat-visible"
        v-if="loggedIn"
        :class="{'sidebar-collapsed--chat' : sidebarStateRight, 'sidebar-collapsed' : sidebarStateLeft}"
    >
        <app-left-panel></app-left-panel>
        <app-conversation :is-fetch="isFetch"></app-conversation>
        <app-right-panel v-if="techChatsIds.every(el => el !== currentChannel.id)"></app-right-panel>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import RightPanel from './RightPanel.vue';
    import LeftPanel from './LeftPanel.vue';
    import Conversation from './Conversation.vue';

    export default {
        data: () => ({
            isFetch: false,
        }),
        computed: {
            ...mapGetters([
                'loggedIn',
                'loggedInHash',
                'sidebarStateLeft',
                'sidebarStateRight',
                'messages',
                'channel',
                'userData',
                'techChat',
                'techChatsIds',
            ]),
            currentChannel() {
                return this.channel !== undefined && this.channel !== null ? this.channel : []
            },
        },
        components: {
            appRightPanel: RightPanel,
            appLeftPanel: LeftPanel,
            appConversation: Conversation,
        },
        created() {
            this.loadChat();

        },
        methods: {
            loadChat() {
                if (this.userData === null) return;

                this.isFetch = true;
                this.$store.dispatch('channel', this.$route.params.id).then(res => {
                    let ids = [];
                    res.data.data.members.forEach(item => {
                       ids.push(item.id)
                    });

                    if((!ids.includes(this.userData?.id) || ids.length === 0) && !res.data.data.is_tech) {
                        this.$router.push({name: 'profile'})
                    }
                    this.isFetch = false;
                }, err => {
                    this.isFetch = false;

                    if (err.message && (err.message === 'cancel before fetch personal_channel' || err.message === 'cancel before fetch channel')) return;

                    this.$router.push({name: 'profile'});
                });
            }
        },
        watch: {
            loggedInHash: function (val) {
                if(!this.loggedIn){
                    this.$router.push({ name: 'login' });
                }
            },
            '$route' (to, from) {
                this.loadChat();
            },
            userData: 'loadChat',
        }
    }
</script>

<style lang="scss" scoped>
@media screen and (min-width: 768px) {
  .page-container.sidebar-collapsed {
    background-color: #fff;

    & ::v-deep .sidebar-menu {
      width: auto;
      min-width: auto;

      .logo-env > div.sidebar-collapse {
        left: 0;
      }

      #main-menu > li > a span {
        display: none;
      }

      & + .main-content .comment {
        position: relative;
        bottom: 0;
        left: 0;
        padding: 28px 20px 22px 20px;
        width: 100%;

        .button--choose-groups {
            left: 15px;
            top: 35px;
        }
      }
    }

    & ::v-deep .aside-menu__icon {
      margin-right: 0;
    }
    
    .main-content--wide {
      width: calc(100% - 65px) !important;
      margin-left: 65px;
    }
  }
}
</style>

